export enum ExportDataStatuses {
  InQueue = 'InQueue',
  Generating = 'Generating',
  Generated = 'Generated',
  Failed = 'Failed',
  Canceled = 'Canceled',
}
